import axios from "axios";
import { Message } from "element-ui";
import store from "@/store";
import { request_url } from "../config/global_config";
export const url = request_url;
// create an axios instance
const service = axios.create({
  baseURL: request_url, // url = base url + request url
  // timeout: 10000 // request timeout
});

// request interceptor
service.interceptors.request.use(
  config => {    
    if (store.state.oidcStore.id_token) {
      config.headers["Authorization"] =
        "Bearer " + store.state.oidcStore.id_token;
    }
    if(localStorage.getItem("jwtToken")){
      config.headers["Authorization"] =
      "Bearer " + localStorage.getItem("jwtToken");
    }
    if(localStorage.getItem("admin_jwtToken")){
      config.headers["Authorization"] =
      "Bearer " + localStorage.getItem("admin_jwtToken");
    }
    
    let isUat = JSON.parse(localStorage.getItem("$myconfig")).isUat;
    let account = store.state.Config.applicationId;
    if (
      store.state.Config.studentType === "old" &&
      isUat === "true" &&
      account
    ) {
      config.headers["test_account"] = store.state.Config.applicationId;
    }
    config.headers["Culture"] =
      !localStorage.getItem("lang") || localStorage.getItem("lang") === "zh-TW"
        ? "zh-MO"
        : localStorage.getItem("lang") === "en"
          ? "en-US"
          : localStorage.getItem("lang");
    return config;
  },
  error => {
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code && res.code !== 1000) {
      console.log(res);
      Message({
        message: res.message || "Error",
        type: "error",
        duration: 5 * 1000
      });
      return Promise.reject(new Error(res.message || "Error"));
    } else {
      return res;
    }
  },
  error => {
    console.log("err" + error); // for debug
    Message({
      message: error.message,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

export default service;
